import { Link } from "react-router-dom";
import { usePublicSiteContent } from "../../../hooks/useSiteContent";
import { whatsappUrl } from "../../../lib/siteContentStore";

export default function LoginSection() {
  const content = usePublicSiteContent();

  return (
    <section className="bg-farm-cream py-16 px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-5">
        <div className="rounded-[28px] border border-farm-border bg-farm-warm p-6 md:p-8 shadow-sm">
          <div className="flex flex-col md:flex-row gap-5 md:items-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-farm-earth-light text-farm-brown shrink-0">
              <i className="ri-clipboard-line text-3xl" />
            </div>
            <div>
              <span className="font-body text-xs font-bold tracking-[0.22em] text-farm-earth">
                MÜŞTERİ PANELİ
              </span>
              <h2 className="mt-1 font-heading text-2xl md:text-3xl font-bold text-farm-brown">
                Siparişlerinizi Takip Edin (Yakında)
              </h2>
              <p className="mt-2 font-body text-sm md:text-base text-farm-muted leading-relaxed">
                Müşteri panelinize giriş yaparak kurbanlık veya hisse siparişinizin kesim planını ve teslimat durumunu takip edebilirsiniz.
              </p>
            </div>
          </div>
        </div>

        <div className="rounded-[28px] border border-farm-border bg-farm-warm p-6 md:p-8 shadow-sm">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-farm-brown">Kayıt ve Bilgi</h3>
          <p className="mt-2 font-body text-sm text-farm-muted leading-relaxed">
            Yeni müşteri kayıtları WhatsApp üzerinden alınmaktadır. Paket, teslimat ve kesim planı için bizimle iletişime geçebilirsiniz.
          </p>
          <div className="mt-5 flex flex-col sm:flex-row gap-3">
            <a
              href={whatsappUrl(content)}
              target="_blank"
              rel="nofollow noopener"
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-farm-green px-5 py-3 text-white font-body font-bold hover:bg-farm-green/90 transition-colors"
            >
              <i className="ri-whatsapp-line text-xl" />
              WhatsApp ile Kayıt Ol
            </a>
            <Link
              to="/giris"
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-farm-earth/30 bg-farm-cream px-5 py-3 text-farm-brown font-body font-bold hover:bg-farm-earth-light transition-colors"
            >
              <i className="ri-login-box-line text-xl" />
              Müşteri Girişi
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
